import md5 from 'blueimp-md5'

/**
 * Short, non-reversible fingerprint of an access token. Lets the readable
 * `kidsout__at_meta` cookie signal which token is current without exposing any
 * token bytes to third-party scripts that can read `document.cookie`.
 */
export const accessTokenHash = (token: string): string => md5(token).slice(0, 8)
